import { theme } from '~/tailwind.js';

export default function () {
    let onScreens = {};
    Object.keys(theme.screens).forEach(key => {
        onScreens[key] = window.innerWidth >= window.parseInt(theme.screens[key]);
    });

    return onScreens;
};
